import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { vigboTariffs } from 'reactApp/appHelpers/featuresHelpers/features/vigbo';
import { getLatestExpiredSubscription } from 'reactApp/modules/billingData/billingData.helpers';
import { PastSubscriptionsSelectors } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.selectors';
import { getPaySource } from 'reactApp/modules/payment/payment.analytics';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { getVigboProductIdByTrial } from 'reactApp/modules/vigbo/vigbo.helpers';
import type { RootState } from 'reactApp/store';
import { InformationAlertBanner, InformationBannerType } from 'reactApp/ui/InformationAlertBanner/InformationAlertBanner';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

export const VigboEndTariffBanner = memo(() => {
    const dispatch = useDispatch();

    const vigboFinishedSubs = useSelector((state: RootState) =>
        PastSubscriptionsSelectors.getPastSubscriptionsByProductIds(state, vigboTariffs)
    );
    const latestFinishedTariff = useMemo(() => getLatestExpiredSubscription(vigboFinishedSubs), [vigboFinishedSubs]);

    useEffect(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.vigbo,
            action: 'show-banner-end-sub',
        });
    }, []);

    const handleClick = useCallback(() => {
        if (!latestFinishedTariff) {
            return;
        }

        const productId = latestFinishedTariff.isTrial ? getVigboProductIdByTrial(latestFinishedTariff) : latestFinishedTariff.productId;
        if (productId) {
            productsController.updateProducts(productId).then((product) => {
                if (!product || !product.available) {
                    return;
                }

                dispatch(
                    openTariffBuy({
                        productId: product.id,
                        paySource: getPaySource('vigbo-end-tariff-banner'),
                        vigboSkipRedirect: true,
                    })
                );
            });
        }

        sendPaymentGa({
            eventCategory: ECategoryGa.vigbo,
            action: 'click-banner-end-sub',
        });
    }, [latestFinishedTariff]);

    return (
        <InformationAlertBanner
            title="Ваша подписка для фотографов закончилась"
            content="Подключите её снова — сможете создавать галереи Vigbo и ретушировать снимки сериями"
            primaryButtonTitle="Подключить со скидкой"
            type={InformationBannerType.info}
            onPrimaryClick={handleClick}
        />
    );
});

VigboEndTariffBanner.displayName = 'VigboEndTariffBanner';
